import React from 'react'
import {
  DsBox,
  DsButton,
  DsImage,
  DsRemixIcon,
  DsStack,
  DsTypography
} from '@am92/react-design-system'

import { T_LANDING_PAGE_CONSTANTS } from '../Landing.PageConstants/TYPES'

import { APP_GET_STARTED_URL } from '~/src/Configurations/env'

import LANDING_INTRO from '~/src/Assets/LANDING/LANDING_INTRO'
interface IPageIntroProps {
  PAGE_CONSTANTS: T_LANDING_PAGE_CONSTANTS
}

const PageIntro: React.FC<IPageIntroProps> = props => {
  const { PAGE_CONSTANTS } = props

  const handleGetStartedClick = () => {
    window.open(APP_GET_STARTED_URL, '_blank')
  }

  return (
    <DsStack
      direction={{
        xs: 'column-reverse',
        md: 'row'
      }}
      alignItems='center'
      justifyContent='space-between'
      spacing={{
        xs: 'var(--ds-spacing-mild)',
        md: 'var(--ds-spacing-hot)'
      }}
      sx={{
        px: {
          xs: 'var(--ds-spacing-bitterCold)',
          md: 'var(--ds-spacing-hot)'
        }
      }}
    >
      <DsStack
        direction='column'
        alignItems={{ xs: 'center', md: 'flex-start' }}
        spacing='var(--ds-spacing-frostbite)'
        sx={{ maxWidth: '600px', width: '100%' }}
      >
        <DsTypography
          variant='subheadingSemiboldLarge'
          textAlign={{ xs: 'center', md: 'left' }}
          color='primary'
        >
          {PAGE_CONSTANTS.PAGE_KICKER}
        </DsTypography>
        <DsTypography
          variant='headingBoldExtraLarge'
          textAlign={{ xs: 'center', md: 'left' }}
        >
          {PAGE_CONSTANTS.PAGE_TITLE}
        </DsTypography>
        <DsTypography
          variant='bodyRegularLarge'
          color='text.secondary'
          textAlign={{ xs: 'center', md: 'left' }}
        >
          {PAGE_CONSTANTS.PAGE_DESCRIPTION}
        </DsTypography>
        <DsStack
          direction='column'
          spacing='var(--ds-spacing-bitterCold)'
          alignItems='flex-start'
          sx={{
            width: '100%',
            py: {
              xs: 'var(--ds-spacing-frostbite)',
              md: 'var(--ds-spacing-mild)'
            }
          }}
        >
          <DsStack
            direction='row'
            spacing='var(--ds-spacing-mild)'
            alignItems='flex-start'
          >
            <DsRemixIcon
              className='ri-book-open-line'
              sx={{ color: 'primary.main', fontSize: '24px', pt: '4px' }}
            />
            <DsStack direction='column' spacing='var(--ds-spacing-quickFreeze)'>
              <DsTypography variant='bodyBoldLarge'>
                {PAGE_CONSTANTS.CARD_1_TITLE}
              </DsTypography>
              <DsTypography variant='bodyRegularLarge' color='text.secondary'>
                {PAGE_CONSTANTS.CARD_1_DESCRIPTION}
              </DsTypography>
            </DsStack>
          </DsStack>
          <DsStack
            direction='row'
            spacing='var(--ds-spacing-mild)'
            alignItems='flex-start'
          >
            <DsRemixIcon
              className='ri-lightbulb-line'
              sx={{ color: 'primary.main', fontSize: '24px', pt: '4px' }}
            />
            <DsStack direction='column' spacing='var(--ds-spacing-quickFreeze)'>
              <DsTypography variant='bodyBoldLarge'>
                {PAGE_CONSTANTS.CARD_2_TITLE}
              </DsTypography>
              <DsTypography variant='bodyRegularLarge' color='text.secondary'>
                {PAGE_CONSTANTS.CARD_2_DESCRIPTION}
              </DsTypography>
            </DsStack>
          </DsStack>
          <DsStack
            direction='row'
            spacing='var(--ds-spacing-mild)'
            alignItems='flex-start'
          >
            <DsRemixIcon
              className='ri-star-line'
              sx={{ color: 'primary.main', fontSize: '24px', pt: '4px' }}
            />
            <DsStack direction='column' spacing='var(--ds-spacing-quickFreeze)'>
              <DsTypography variant='bodyBoldLarge'>
                {PAGE_CONSTANTS.CARD_3_TITLE}
              </DsTypography>
              <DsTypography variant='bodyRegularLarge' color='text.secondary'>
                {PAGE_CONSTANTS.CARD_3_DESCRIPTION}
              </DsTypography>
            </DsStack>
          </DsStack>
        </DsStack>
        <DsBox>
          <DsButton
            size='large'
            sx={{ width: '280px' }}
            onClick={handleGetStartedClick}
          >
            {PAGE_CONSTANTS.GET_STARTED_CTA_TEXT}
          </DsButton>
        </DsBox>
      </DsStack>

      <DsImage
        aspectRatio={1 / 1}
        srcSet={LANDING_INTRO}
        WrapperProps={{
          sx: {
            width: '100%',
            maxWidth: '640px'
          }
        }}
      />
    </DsStack>
  )
}

export default PageIntro
